<template>
  <div class="comment-form">
    <a-list
      v-if="dataSource.length"
      :grid="listGrid"
      :data-source="dataSource"
      item-layout="horizontal"
    >
      <a-list-item
        slot="renderItem"
        slot-scope="item">
        <a-comment
          :content="item.text"
          :datetime="formatDateDMYT(item.created)"
        >
          <template slot="author">
            <a
              :href="`${item.author.url}`"
              :title="getAuthorPrintName(item.author)"
              target="_blank">
              {{ getAuthorPrintName(item.author) }}
            </a>
          </template>
        </a-comment>
      </a-list-item>
    </a-list>
    <template v-if="withAddForm">
      <a-comment data-html2canvas-ignore>
        <div slot="content">
          <a-form-item>
            <a-textarea
              :rows="4"
              :value="comment"
              @change="handleChange" />
          </a-form-item>
          <a-form-item>
            <button
              class="app__form-submit-btn app__button-raised"
              type="button"
              @click.prevent="handleSubmit"
              :disabled="isEmpty || loading">
              {{ 'common.publish' | globalize }}
            </button>
          </a-form-item>
        </div>
      </a-comment>
    </template>
  </div>
</template>

<!--
* @description Component to add-view some comments
*
* @usage
*  <template>
*   <comment-form
*              :data-source="[{
                  text: string,
                  created: datestring,
                  author: {
                    id,
                    ?firstName,
                    ?lastName,
                    ?fullName,
                    url
                    ethAddress
                  }
                }]"
*              :loading="boolean"
*              :on-add="function (value) { ... }"
*              />
*   </template>
*   <script>
*     import VerificationCommentForm from '@/vue/common/comments'
      export default {
        ...
        components: {
          'comment-form': VerificationCommentForm,
        }
      }
*   </script>
-->

<script>

import AList from 'ant-design-vue/lib/list'
import AComment from 'ant-design-vue/lib/comment'
import AForm from 'ant-design-vue/lib/form'
import AInput from 'ant-design-vue/lib/input'
import { formatDateDMYT } from '@/vue/filters/formatDateDMYT'
import { shortener } from '@/js/helpers/string'

export default {
  name: 'comment-form',
  components: {
    'a-list': AList,
    'a-comment': AComment,
    'a-form-item': AForm.Item,
    'a-list-item': AList.Item,
    'a-textarea': AInput.TextArea,
  },
  props: {
    dataSource: { type: Array, required: true },
    listSize: { type: Number, default: 10 },
    loading: { type: Boolean },
    onAdd: { type: Function, required: true },
    withAddForm: { type: Boolean, default: true },
  },
  data () {
    return {
      comment: '',
      isEmpty: true,
      listGrid: {
        column: 8,
        size: 12,
      },
    }
  },
  methods: {
    async handleSubmit () {
      await this.onAdd(this.comment)
      this.comment = ''
      this.isEmpty = true
    },
    handleChange (e) {
      this.comment = e.target.value
      this.isEmpty = !this.comment
    },
    getAuthorPrintName (author) {
      if (author.fullName) {
        return author.fullName
      }
      if (author.firstName && author.lastName) {
        return `${author.firstName} ${author.lastName}`
      }
      if (author.ethAddress) {
        return shortener(author.ethAddress)
      }
      return author.id
    },
    formatDateDMYT,
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/list/style/index.css';
  @import '~ant-design-vue/lib/form/style/index.css';
  @import '~ant-design-vue/lib/comment/style/index.css';
  @import '~ant-design-vue/lib/input/style/index.css';
</style>
